export const getCookieUrl = (market, language) => {
  return `https://www.polestar.com/${getSiteSlugByMarket(market, language)}/legal/privacy/cookies/`;
};

const marketsMap = {
  'fr-BE': 'fr-be',
  'nl-BE': 'nl-be',
  DK: 'dk',
  DE: 'de',
  ES: 'es',
  IS: 'is-is',
  IE: 'ie',
  IT: 'it',
  LU: 'fr-lu',
  NL: 'nl',
  FR: 'fr',
  NO: 'no',
  PT: 'pt',
  'fr-CH': 'fr-ch',
  'de-CH': 'de-ch',
  'it-CH': 'it-ch',
  FI: 'fi',
  SE: 'se',
  GB: 'uk',
  AT: 'at',
  'en-CA': 'en-ca',
  'fr-CA': 'fr-ca',
  US: 'us',
  AU: 'au',
  HK: 'hk',
  KR: 'kr',
  NZ: 'nz',
  SG: 'en-sg',
  CN: 'zh-cn',
  IL: 'en-il',
  KW: 'en-kw',
  'en-AE': 'en-ae',
  'ar-AE': 'ar-ae',
};

export const getSiteSlugByMarket = (market, language) => {
  return (
    marketsMap[market] ||
    marketsMap[`${language}-${market}`] ||
    marketsMap['GB']
  );
};
